import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'videoSan'
})
export class VideoPipe implements PipeTransform {

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  transform = (video: string, args?: any): SafeResourceUrl => {
    const watch = 'watch?v=';
    const embed = 'embed/';
    const https = 'https://www.youtube.com/';
    video = video.includes(watch) ? video.replace(watch, embed) : video;
    video = video.includes(https) ? video.includes(https + embed) ?
      video : https + embed + video : https + video;

    return this.domSanitizer.bypassSecurityTrustResourceUrl(video);
  }

}
